import React from "react";
import { Card, Grid, Typography, Box } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import { makeStyles } from "@material-ui/core/styles";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import PipelineGoalTable from "./PipelineGoalTable";
import DataTableNew from "./DataTableNew";
import SplitByTable from "./SplitByTable";
import WeeklyBuildPipeTable from "./WeeklyBuildPipeTable";

// Styles for error messages
const useStyles = makeStyles((theme) => ({
  errorBox: {
    padding: theme.spacing(3),
    margin: theme.spacing(2),
    backgroundColor: "#fff3cd",
    border: "1px solid #ffc107",
    borderRadius: "4px",
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
  },
  errorIcon: {
    color: "#ff9800",
    fontSize: "2rem",
  },
  errorText: {
    color: "#856404",
    fontSize: "1rem",
    fontWeight: 500,
  },
}));

const PipelineSufficiencySection = ({ pipelineData, loading, handleChangeLocation }) => {
  const classes = useStyles();

  if (loading || pipelineData === "") {
    return (
      <Grid container spacing={3}>
        {[1, 2, 3, 4].map((item) => (
          <Grid component={Card} style={{ marginTop: "2rem" }} item xs={12} key={item}>
            <Grid item xs={12} id="grid-container">
              <Grid item container component={Card} justify="center">
                <Skeleton
                  animation="wave"
                  variant="rect"
                  width="80%"
                  height={200}
                  style={{ margin: "20px 0px" }}
                />
              </Grid>
            </Grid>
          </Grid>
        ))}
      </Grid>
    );
  }

  // Check for Lead Source and Cust Type errors
  const hasLeadSourceData = pipelineData.hasLeadSourceData;
  const hasCustTypeData = pipelineData.hasCustTypeData;
  const leadSourceError = pipelineData.leadSourceError;
  const custTypeError = pipelineData.custTypeError;

  return (
    <>
      {/* Pipeline Goal Section */}
      <Grid component={Card} style={{ marginTop: "2rem" }} item xs={12}>
        <Grid item xs={12} id="grid-container">
          <Grid item container xs={12} justify="center">
            <Grid style={{ padding: "1rem 2rem" }}>
              <Grid item container xs={12} justify="center">
                <Grid item xs={1}></Grid>
                <Grid item xs={10}>
                  <Typography
                    variant="h2"
                    style={{
                      width: "100%",
                      margin: "auto",
                      padding: "1rem",
                      paddingTop: "0.3rem",
                    }}
                    align="center"
                  >
                    Pipeline Goal
                  </Typography>
                </Grid>
                <Grid item xs={1} align="right"></Grid>
              </Grid>
              <PipelineGoalTable
                quarters={pipelineData.fiscalQuarters}
                data={pipelineData.pipelineData}
                dataTest="PGSA-Pipeline-Goal"
                id="PSCA"
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* Actual Pipeline By Stage Section */}
      <Grid component={Card} style={{ marginTop: "2rem" }} item xs={12}>
        <Grid item xs={12} id="grid-container">
          <Grid item container xs={12} justify="center">
            <Grid style={{ padding: "1rem 2rem" }}>
              <Grid item container xs={12} justify="center">
                <Grid item xs={1}></Grid>
                <Grid item xs={10}>
                  <Typography
                    variant="h2"
                    style={{
                      width: "100%",
                      margin: "auto",
                      padding: "1rem",
                      paddingTop: "0.3rem",
                    }}
                    align="center"
                  >
                    Actual Pipeline (By Stage)
                  </Typography>
                </Grid>
                <Grid item xs={1} align="right"></Grid>
              </Grid>
              <DataTableNew
                quarters={pipelineData.fiscalQuarters}
                data={pipelineData.actualPipelineByStage}
                stages={pipelineData.stages}
                dataTest="PGSA-Actual-Pipeline"
                id="PSCA"
                handleChangeLocation={handleChangeLocation}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* Pipeline By Lead Source Section */}
      {hasLeadSourceData ? (
        <Grid component={Card} style={{ marginTop: "2rem" }} item xs={12}>
          <Grid item xs={12} id="grid-container">
            <Grid item container xs={12} justify="center">
              <Grid style={{ padding: "1rem 2rem" }}>
                <Grid item container xs={12} justify="center">
                  <Grid item xs={1}></Grid>
                  <Grid item xs={10}>
                    <Typography
                      variant="h2"
                      style={{
                        width: "100%",
                        margin: "auto",
                        padding: "1rem",
                        paddingTop: "0.3rem",
                      }}
                      align="center"
                    >
                      Pipeline By Lead Source
                    </Typography>
                  </Grid>
                  <Grid item xs={1} align="right"></Grid>
                </Grid>
                <SplitByTable
                  quarters={pipelineData.fiscalQuarters}
                  data={pipelineData.leadSourceData}
                  uniqueTypes={pipelineData.uniqueLeadSource}
                  dataTest="PGSA-Pipeline-ByLead-Source"
                  type="Lead_Source"
                  id="PSCA"
                  firstColumnHeader="Lead Source"
                  handleChangeLocation={handleChangeLocation}
                  percentages={pipelineData.leadSourcePercentages}
                />
              </Grid>
            </Grid>
          </Grid>

           <Grid item xs={12} id="grid-container">
            <Grid item container xs={12} justify="center">
              <Grid style={{ padding: "2rem 2rem" }}>
                <Grid item container xs={12} justify="center">
                  <Grid item xs={1}></Grid>
                  <Grid item xs={10}>
                    <Typography
                      variant="h2"
                      style={{
                        width: "100%",
                        margin: "auto",
                        padding: "1rem",
                        paddingTop: "0.3rem",
                        paddingBottom: "0rem"
                      }}
                      align="center"
                    >
                     Weekly pipeline build goal
                    </Typography>
                  </Grid>
                  <Grid item xs={1} align="right"></Grid>
                </Grid>
                <Grid item container xs={12} justify="center">
                  <Grid item xs={1}></Grid>
                  <Grid item xs={10}>
                    <Typography
                      variant="body1"
                      style={{
                        width: "100%",
                        margin: "auto",
                        padding: "1rem",
                        paddingTop: "0rem",
                        paddingBottom: "0rem"
                      }}
                      align="center"
                    >
                    (Quarterly delta divided by 13 weeks)
                    </Typography>
                  </Grid>
                  <Grid item xs={1} align="right"></Grid>
                </Grid>
                <WeeklyBuildPipeTable
                  quarters={pipelineData.fiscalQuarters}
                  data={pipelineData.leadSourceWeeklyPipeBuild}
                  uniqueTypes={pipelineData.uniqueLeadSource}
                  dataTest="PGSA-Pipeline-ByLead-Source_Weekly"
                  type="Lead_Source"
                  id="PSCA"
                  firstColumnHeader="Lead Source"
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      ) : leadSourceError ? (
        <Grid component={Card} style={{ marginTop: "2rem" }} item xs={12}>
          <Grid item xs={12} id="grid-container">
            <Grid item container xs={12} justify="center">
              <Grid style={{ padding: "1rem 2rem", width: "100%" }}>
                <Grid item container xs={12} justify="center">
                  <Grid item xs={1}></Grid>
                  <Grid item xs={10}>
                    <Typography
                      variant="h2"
                      style={{
                        width: "100%",
                        margin: "auto",
                        padding: "1rem",
                        paddingTop: "0.3rem",
                        paddingBottom: '0rem'
                      }}
                      align="center"
                    >
                      Pipeline By Lead Source
                    </Typography>
                  </Grid>
                  <Grid item xs={1} align="right"></Grid>
                </Grid>
                 <Grid item xs={12} style={{marginTop: '2rem'}}>
                <Box className={classes.errorBox} style={{ 
      width: 'fit-content',
      maxWidth: '90%',
      margin: '0px'
    }}>
                  <ErrorOutlineIcon className={classes.errorIcon} />
                  <Typography className={classes.errorText}>
                    {leadSourceError.message}
                  </Typography>
                </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      ) : null}

      {/* Pipeline By Customer Type Section */}
      {hasCustTypeData ? (
        <Grid component={Card} style={{ marginTop: "2rem" }} item xs={12}>
          <Grid item xs={12} id="grid-container">
            <Grid item container xs={12} justify="center">
              <Grid style={{ padding: "1rem 2rem" }}>
                <Grid item container xs={12} justify="center">
                  <Grid item xs={1}></Grid>
                  <Grid item xs={10}>
                    <Typography
                      variant="h2"
                      style={{
                        width: "100%",
                        margin: "auto",
                        padding: "1rem",
                        paddingTop: "0.3rem",
                        paddingBottom: '0rem'
                      }}
                      align="center"
                    >
                      Pipeline By Customer Type
                    </Typography>
                  </Grid>
                  <Grid item xs={1} align="right"></Grid>
                </Grid>
             
                <SplitByTable
                  quarters={pipelineData.fiscalQuarters}
                  data={pipelineData.custTypeData}
                  uniqueTypes={pipelineData.uniqueCustType}
                  dataTest="PGSA-Pipeline-By_Cust_Type"
                  type="Cust_Type"
                  id="PSCA"
                  firstColumnHeader="Customer Type"
                  handleChangeLocation={handleChangeLocation}
                  percentages={pipelineData.custTypePercentages}
                />
              </Grid>
            </Grid>
          </Grid>

           <Grid item xs={12} id="grid-container">
            <Grid item container xs={12} justify="center">
              <Grid style={{ padding: "2rem 2rem" }}>
                <Grid item container xs={12} justify="center">
                  <Grid item xs={1}></Grid>
                  <Grid item xs={10}>
                    <Typography
                      variant="h2"
                      style={{
                        width: "100%",
                        margin: "auto",
                        padding: "1rem",
                        paddingTop: "0.3rem",
                        paddingBottom: "0rem"
                      }}
                      align="center"
                    >
                     Weekly pipeline build goal
                    </Typography>
                  </Grid>
                  <Grid item xs={1} align="right"></Grid>
                </Grid>
                    <Grid item container xs={12} justify="center">
                  <Grid item xs={1}></Grid>
                  <Grid item xs={10}>
                    <Typography
                     variant="body1"
                      style={{
                        width: "100%",
                        margin: "auto",
                        padding: "1rem",
                        paddingTop: "0rem",
                        paddingBottom: "0rem"
                      }}
                      align="center"
                    >
                    (Quarterly delta divided by 13 weeks)
                    </Typography>
                  </Grid>
                  <Grid item xs={1} align="right"></Grid>
                </Grid>
                <WeeklyBuildPipeTable
                  quarters={pipelineData.fiscalQuarters}
                  data={pipelineData.cusTypeWeeklyPipeBuild}
                  uniqueTypes={pipelineData.uniqueCustType}
                  dataTest="PGSA-Pipeline-ByCust_Type_Weekly"
                  type="Cust_Type"
                  id="PSCA"
                    firstColumnHeader="Customer Type"
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      ) : custTypeError ? (
        <Grid component={Card} style={{ marginTop: "2rem" }} item xs={12}>
          <Grid item xs={12} id="grid-container">
            <Grid item container xs={12} justify="center">
              <Grid style={{ padding: "1rem 2rem", width: "100%" }}>
                <Grid item container xs={12} justify="center">
                  <Grid item xs={1}></Grid>
                  <Grid item xs={10}>
                    <Typography
                      variant="h2"
                      style={{
                        width: "100%",
                        margin: "auto",
                        padding: "1rem",
                        paddingTop: "0.3rem",
                      }}
                      align="center"
                    >
                      Pipeline By Customer Type
                    </Typography>
                  </Grid>
                  <Grid item xs={1} align="right"></Grid>
                </Grid>
                 <Grid item xs={12} style={{marginTop: '2rem'}}>
                <Box className={classes.errorBox} style={{ 
      width: 'fit-content',
      maxWidth: '90%',
      margin: '0px'
    }}>
                  <ErrorOutlineIcon className={classes.errorIcon} />
                  <Typography className={classes.errorText}>
                    {custTypeError.message}
                  </Typography>
                </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      ) : null}
    </>
  );
};

export default PipelineSufficiencySection;